import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';

@Injectable()
export class AuthenticationService implements OnInit {

  ngOnInit(): void {

  }

  constructor(private http: HttpClient
    /*, private jwtHelper: JwtHelperService*/) {

  }

  login(credentials) {
    //return this.http.post(AppSettingsService.settings.dartArtGalleryApiUrl + 'api/authenticate',
    //  JSON.stringify(credentials))
    //  .map(response => {
    //    console.log(response);
    //    return false;
    //  });
    return false;
  }

  logout() {
    localStorage.removeItem('token');
  }

  isLoggedIn() {
    return true;
    //return this.jwtHelper.isTokenExpired();
  }

  get currentUser() {
    return null;
    /*let token = localStorage.getItem('token');
    return this.jwtHelper.decodeToken(token);*/
  }

}
